import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e4cb5fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "evaluation_detail_content" }
const _hoisted_2 = { class: "head_content" }
const _hoisted_3 = { class: "evaluation_time" }
const _hoisted_4 = { class: "evaluation-detail-bg" }
const _hoisted_5 = {
  key: 0,
  class: "empty-card"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-card-text" }, [
  /*#__PURE__*/_createElementVNode("div", null, "评测数据暂未生成")
], -1))
const _hoisted_7 = {
  key: 1,
  class: "evaluation-detail"
}
const _hoisted_8 = { class: "top_info" }
const _hoisted_9 = {
  key: 0,
  id: "chart"
}
const _hoisted_10 = {
  key: 1,
  class: "bottom_info"
}
const _hoisted_11 = { class: "group_tab_bg" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space_line" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "detail_text_bg"
}
const _hoisted_15 = { class: "result_detail" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "suggest_title" }, "【建议】", -1))
const _hoisted_17 = { class: "suggest_detail" }
const _hoisted_18 = {
  key: 2,
  class: "qr_code_info"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "radar_detail_bg"
}
const _hoisted_22 = { class: "detail_text_content" }
const _hoisted_23 = { class: "result_title" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result_title" }, "【结果】", -1))
const _hoisted_25 = { class: "result_detail" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "suggest_title" }, "【建议】", -1))
const _hoisted_27 = { class: "suggest_detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, "我的评测报告-" + _toDisplayString(_ctx.detailInfo ? _ctx.detailInfo.title : "--"), 1),
      _createElementVNode("span", _hoisted_3, "评测时间：" + _toDisplayString(_ctx.detailInfo ? _ctx.detailInfo.createDate : "--|--"), 1)
    ]),
    _createVNode(_component_van_image, {
      class: "back_action",
      src: require('../assets/image/white_btn_icon.svg'),
      onClick: _ctx.close
    }, null, 8, ["src", "onClick"]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.detailInfo && !_ctx.detialLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_van_image, {
              src: require('../assets/image/icon-empty-dark.png')
            }, null, 8, ["src"]),
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
      (_ctx.detailInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.detailInfo.resultIntro), 1),
            (_ctx.detailInfo.type == 'radar')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("ul", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailInfo.reportList, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", null, [
                        _createElementVNode("div", {
                          class: _normalizeClass([
                  'group_tab_item',
                  item.extra == '是'
                    ? _ctx.cureentScaleDetail == item
                      ? 'group_tab_item_extra_selected'
                      : 'group_tab_item_extra'
                    : _ctx.cureentScaleDetail == item
                    ? 'group_tab_item_selected'
                    : '',
                ]),
                          onClick: ($event: any) => (_ctx.groupTabItemClick(index))
                        }, _toDisplayString(item.group), 11, _hoisted_12)
                      ]))
                    }), 256))
                  ]),
                  _hoisted_13,
                  (_ctx.cureentScaleDetail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                'result_title',
                _ctx.cureentScaleDetail.extra == '是' ? 'result_title_extra' : '',
              ])
                        }, "【结果】" + _toDisplayString(_ctx.cureentScaleDetail.result), 3),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.cureentScaleDetail.analysis), 1),
                        _hoisted_16,
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.cureentScaleDetail.advice), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])),
            (_ctx.detailInfo.extraQRCode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("span", {
                    class: "qr_code_title",
                    innerHTML: _ctx.detailInfo.extraTitle
                  }, null, 8, _hoisted_19),
                  _createElementVNode("img", {
                    src: _ctx.detailInfo.extraQRCode,
                    alt: "",
                    class: "qr_code_img"
                  }, null, 8, _hoisted_20)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode(_component_Loading, null, null, 512), [
      [_vShow, _ctx.detialLoading]
    ]),
    (_ctx.showRadarDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", {
            class: "radar_detail_click_view",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.radarDetailCick && _ctx.radarDetailCick(...args)))
          }),
          (_ctx.cureentScaleDetail)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "detail_text_bg",
                style: _normalizeStyle(_ctx.radarDetailStyle)
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.cureentScaleDetail.group), 1),
                  _hoisted_24,
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.cureentScaleDetail.analysis), 1),
                  _hoisted_26,
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.cureentScaleDetail.advice), 1)
                ])
              ], 4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}